/**
 * Sessão do usuário no site: quem está logado, o que pode fazer e as pendências
 * do primeiro acesso. A fonte da verdade é a API (GET /api/auth/eu).
 * O site só ESCONDE o que o perfil não pode usar; quem bloqueia de verdade é a API.
 */
import { type Agravo, type Escopo, type Perfil, type Permissao } from '@metaepi/shared';
import { createContext, useContext } from 'react';

export interface Conta {
  usuario: {
    id: string;
    nome: string;
    email: string;
    perfil: Perfil;
    municipioIbge: string | null;
    unidadeSaudeId: string | null;
  };
  pendencias: { cienciaPrivacidade: boolean; trocarSenha: boolean };
  permissoes: { permissao: Permissao; escopo: Escopo }[];
  agravosDisponiveis: Record<Agravo, boolean>;
}

export interface ValorSessao {
  conta: Conta | null;
  carregando: boolean;
  pode: (permissao: Permissao) => boolean;
  temPendencias: boolean;
  atualizar: () => Promise<unknown>;
  sair: () => Promise<void>;
  /** Por que a conta deixou de existir: a sessão expirou ou a pessoa saiu. */
  motivoSaida: 'expirada' | 'saiu' | null;
}

export const ContextoSessao = createContext<ValorSessao | null>(null);
export const CHAVE_CONTA = ['conta'] as const;

export function useSessao(): ValorSessao {
  const valor = useContext(ContextoSessao);
  if (!valor) throw new Error('useSessao precisa estar dentro de <ProvedorSessao>');
  return valor;
}
